import { type NodeViewProps } from '@tiptap/core'
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'

export const Component = (props: NodeViewProps) => {
	const { editor } = props
	const align = props.node.attrs.align
	const editable = editor.isEditable

	if (editable) {
		return (
			<NodeViewWrapper>
				<div className="flex pt-1" style={{ justifyContent: align }}>
					<NodeViewContent
						className={`w-fit [&>*]:flex [&>*]:items-center [&>*]:gap-[var(--dynamic-gap)]`}
						style={{
							'--dynamic-gap': `${props.node.attrs.spacing}px`,
						}}
					/>
				</div>
			</NodeViewWrapper>
		)
	} else {
		return (
			<NodeViewWrapper>
				<div className="flex" style={{ justifyContent: align }}>
					<NodeViewContent
						className={`w-fit [&>*]:flex [&>*]:items-center [&>*]:gap-[var(--dynamic-gap)]`}
						style={{
							'--dynamic-gap': `${props.node.attrs.spacing}px`,
						}}
					/>
				</div>
			</NodeViewWrapper>
		)
	}
}

export default Component
